import * as yup from "yup";

export const PmsReportSchema = yup.object().shape({
  pms: yup.string().required("Please Select PMS!"),
  mydocs_report_name: yup.string().required("Please Enter myDocs Report Name!"),
  report_name: yup.string().required("Please Enter Report Name!"),
  mydocs_report_type: yup.string().required("Please Select a Report Type!"),
  source_type: yup.string().required("Please Select a Submission Method!"),
});

export default { PmsReportSchema };
